import React from "react";
import { useNavigate } from "react-router-dom";
import { useSection } from "../../../i18n/useSection";
import { PERSON_DASHBOARD } from "../../../routes/routerPath";
import { userInfoFetch } from "../../../utlis/commonFunction";
import { clearMeasurementSession } from "./measurementSession";

export default function CancelMeasurementButton() {
  const navigate = useNavigate();
  const { cancel } = useSection("common");

  const handleCancel = () => {
    clearMeasurementSession();
    sessionStorage.removeItem("fromUpload");
    const params = new URLSearchParams(window.location.search);
    const personId = userInfoFetch()?.id;
    params.set("tab", "insights");
    if (personId) {
      params.set("seniorId", personId);
      params.set("seniorUuid", personId);
    }
    navigate(`${PERSON_DASHBOARD}?${params.toString()}`, { replace: true });
  };

  return (
    <button
      type="button"
      className="measurement-cancel-btn"
      onClick={handleCancel}
    >
      {cancel}
    </button>
  );
}
